/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            slogan
            description
            author
            ogImage
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  // if it's the homepage do something different
  // let metaTitle = site.siteMetadata.title
  let isHomepage = false
  let ogTitle = title
  if (title === site.siteMetadata.title) {
    // metaTitle = site.siteMetadata.slogan
    site.siteMetadata.title = site.siteMetadata.slogan
    isHomepage = true
    ogTitle = title + ' - ' + site.siteMetadata.slogan
  }

  // og images
  let ogImage = site.siteMetadata.ogImage
  if (image) {
    ogImage = image
    if (!ogImage.startsWith("https://") && !ogImage.startsWith("//")) {
      ogImage = "https://www.shiftactivemedia.com" + ogImage
    }
    // don't use protocol relative urls
    if (ogImage.startsWith("//")) {
      ogImage = 'https:' + ogImage
    }
  }
  // console.log('image', image)
  // console.log('ogImage', ogImage)

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s - ${site.siteMetadata.title}`}
      // titleTemplate={`%s - -- ${metaTitle}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: ogTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: ogTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)
       .concat(ogImage ? [{property: "og:image", content: ogImage}] : [])
      }
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
